function getAuth0LoginUrl() {
    const returnToUrl = `${window.xrealShopUrl}/pages/redirect`;
    const redirectUrl = `${window.xrealShopUrl}/pages/redirect?pass=unpass`;
    const auth0LoginURL = `${window.auth0Settings.auth0_domain}/authorize?response_type=code&client_id=${window.auth0Settings.auth0_client_id}&return_to=${encodeURIComponent(returnToUrl)}&scope=SCOPE&state=STATE&redirect_uri=${encodeURIComponent(redirectUrl)}`;
    console.log('auth0 Login url', auth0LoginURL)
    return auth0LoginURL;
  }
  
  function getAuth0LogoutUrl() {
    let returnToUrl = `${window.xrealShopUrl}/account/logout`;
    if (`${window.routes.root_url}`.length > 1) {
      returnToUrl = `${window.xrealShopUrl}${window.routes.root_url}/account/logout`;
    }
    const auth0LogoutURL = `${window.auth0Settings.auth0_domain}/v2/logout?response_type=code&client_id=${window.auth0Settings.auth0_client_id}&returnTo=${encodeURIComponent(returnToUrl)}`;
    console.log('auth0 Logout url', auth0LogoutURL)
    return auth0LogoutURL;
  }
  
  function goToAuth0({ action = 'login' }) {
    const logoutURL = getAuth0LogoutUrl();
    const loginURL = getAuth0LoginUrl();
    const auth0URL = action === 'login' ? loginURL : logoutURL;
    if (action === 'logout') {
      localStorage.removeItem('xreal-uid');
    }
    try {
      window.location.href = auth0URL;
    } catch (error) {
      console.error('Failed to navigate to Auth0 logout URL:', error);
    }
  }
  
  function getCurrentProduct() {
    let productTitle = '';
    const xCurrentProduct = document.querySelector(".product__title h1");
    if (xCurrentProduct) {
      productTitle = xCurrentProduct.textContent.trim();
    }
    return productTitle;
  }
  
  // 记录跳转登录前的页面
  const XCurrentURL = window.location.href;
  const xUrlParams = new URLSearchParams(window.location.search);
  if (XCurrentURL.includes('login')) {
    if (xUrlParams.has('checkout_url')) {
      let checkoutUrl = xUrlParams.get('checkout_url');
      checkoutUrl = `{{request.origin}}${checkoutUrl}`;
      localStorage.setItem('xreal-currentURL', checkoutUrl);
    }
  } else if (!XCurrentURL.includes('redirect')) {
    localStorage.setItem('xreal-currentURL', XCurrentURL);
  }
  
  async function getHashString36(str) {
    const encoder = new TextEncoder();
    const data = encoder.encode(str);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const base64Hash = btoa(String.fromCharCode(...new Uint8Array(hashBuffer)));
    return base64Hash.slice(0, 36);
  }
  
  function parsePrice(priceStr) {
    // 正则解析：分离前缀币种、数字部分、后缀币种
    const regex = /([^\d\s,.]+)?[\s]*([\d.,]+)[\s]*([A-Z]{3})?/;
    const match = priceStr.match(regex);
  
    if (match) {
      let prefixCurrency = match[1]?.trim() || ''; // 前缀币种
      const rawNumber = match[2]; // 原始数字部分
      const suffixCurrency = match[3] || ''; // 后缀币种
  
      // 处理数字部分
      const normalizedNumber = rawNumber.replace(/,/g, ''); // 去掉千位分隔符
      const amount = parseFloat(normalizedNumber).toFixed(2); // 保留两位小数
  
      // 确定币种
      let currency = suffixCurrency || prefixCurrency;
  
      // 特殊处理前缀币种的转换
      const currencyMap = {
        '$': 'USD',
        'HK$': 'HKD',
        '€': 'EUR',
        '¥': 'JPY'
      };
      currency = currencyMap[currency] || currency;
  
      return {
        currency,
        amount,
      };
    } else {
      return {
        currency: '',
        amount: '0.00',
      };
    }
  }
  
  function getBeijingTimestamp() {
    const localTime = new Date();
    // 获取当前本地时区偏差（单位：分钟）
    const timeZoneOffset = localTime.getTimezoneOffset();
    // 北京时间 UTC+8(8h * 60)
    const beijingOffset = 480;
    const beijingTime = new Date(localTime.getTime() + (timeZoneOffset + beijingOffset) * 60 * 1000);
    return beijingTime.getTime();
  }